import { useParams } from "react-router-dom";
import { Typography, Button, Card, CardContent, CardMedia } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { useNavigate } from "react-router-dom";
import rummy from '../images/rummy.jpg';
import onehundredoneZ from '../images/onehundredoneZ.png';
import seveneightnineJACKPOTS from '../images/seveneightnineJACKPOTS.png'
import abcrummy from '../images/abc rummy.png';
import Bet213 from '../images/Bet 213.jpg';
import Bingo101 from '../images/Bingo-101.png';
import GoGoRummy from '../images/GoGo-Rummy.png';
import INDSLOTS from '../images/IND SLOTS.png';
import INDBINGO from '../images/IND-BINGO.jpg';
import Jaiho777 from '../images/Jaiho 777.png';
import JaihoArcade from '../images/Jaiho Arcade.png';
import jaihorummy from '../images/jaiho rummy.jpg';
import MDMBet from '../images/MDM Bet.jpg';
import MKMBet from '../images/MKM Bet.png';
import MSMBet from '../images/Msm Bet.png';
import My777 from '../images/My 777.png';
import Rummy365 from '../images/Rummy 365.png';
import SpinLucky from '../images/Spin Lucky.png';
import SpinWinner from '../images/Spin Winner.png';
import SPIN101 from '../images/SPIN-101.png';
import teenpattibliz from '../images/teen patti bliz.jpg';
import teenpattimaster from '../images/teen patti master.jpg';
import Yono777 from '../images/Yono 777.png';
import YonoArcade from '../images/Yono Arcade.png';
import YonoRummy from '../images/Yono Rummy.png';
import YonoSlots from '../images/Yono Slots.png';
import YnRummy from '../images/Yn Rummy.webp';
import SlotsYono567 from '../images/567 Slots Yono.webp';
import EN365YONO from '../images/EN-365-YONO.webp';
import JaihoSpin from '../images/Jaiho Spin.webp';
import Rummy91 from '../images/Rummy 91.webp';
import Rummy420 from '../images/Rummy 420.webp';
import SlotsSpin from '../images/Slots Spin.webp';
import SlotsWinner from '../images/Slots-Winner.webp';
import Spin777 from '../images/Spin-777.webp';
import SpinCrush from '../images/Spin-Crush.webp';
import SpinGold from '../images/Spin-Gold.webp';
import Yn777 from '../images/Yn 777.webp';
import YonoAllGamesWinning from '../images/Yono All Games Winning.webp';
import YonoAllGames from '../images/Yono-All-Games.webp';
import YonoApp from '../images/Yono-App.webp';
import YonoGames from '../images/Yono-Games.webp';
import YonoVip from '../images/Yono-Vip.webp';
import AllYonoApps from '../images/All Yono Apps.webp';
import MQMBet from '../images/MQM-Bet.jpg';
import MWMBET from '../images/MWM.BET.jpg';
import SVIP777 from '../images/SVIP777.jpg';
import MBMBET from '../images/MBM-BET.jpg';
import GAME3F from '../images/GAME3F.webp';
import logo from "../images/logo.jpg";

const games = [
    // ... (your games array)
    {
        id: "new-yono-apps",
        name: "New Yono Apps",
        image: logo,
        bonus: "Bonus Upto ₹1500",
        withdraw: "Min Withdraw ₹100",
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
        type: "join Us"
    },
    {
        id: "66-rummy",
        name: "66-Rummy",
        image: rummy,
        bonus: 51,
        withdraw: 100,
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
    {
        id: "onehundredoneZ",
        name: "101 Z",
        image: onehundredoneZ,
        bonus: 30,
        withdraw: 100,
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
    {
        id: "789 JACKPOTS",
        name: "789 JACKPOTS",
        image: seveneightnineJACKPOTS,
        bonus: 44,
        withdraw: 100,
        downloadLink: "https://789jackpots.in?code=J7Z2AAV5C2M&t=1743505598",
    },
    {
        id: "abc rummy",
        name: "ABC Rummy",
        image: abcrummy,
        bonus: "150",
        withdraw: "100",
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
    {
        id: "Bet213",
        name: "Bet 213",
        image: Bet213,
        bonus: 50,
        withdraw: 100,
        type: "download",
        downloadLink: "https://www.bet213app.com?code=2QTNXR5HN9K&t=1743505802",
    },
    {
        id: "Bingo101",
        name: "Bingo-101",
        image: Bingo101,
        bonus: 40,
        withdraw: 100,
        type: "download",
        downloadLink: "https://bingo101o.com?code=6YFYBTAYA7M&t=1743505637",
    },
    {
        id: "GoGo-Rummy",
        name: "GoGo-Rummy",
        image: GoGoRummy,
        bonus: 22,
        withdraw: 100,
        type: "download",
        downloadLink: "https://www.gogorummy2.com?code=8FWZWA4AZJ1&t=1743505996",
    },
    {
        id: "INDSLOTS",
        name: "IND SLOTS",
        image: INDSLOTS,
        bonus: 50,
        withdraw: 100,
        type: "download",
        downloadLink: "https://www.indslots5.com?code=KLLYRL9J58S&t=1743506040",
    },
    {
        id: "INDBINGO",
        name: "IND-BINGO",
        image: INDBINGO,
        bonus: 20,
        withdraw: 100,
        type: "download",
        downloadLink: "https://www.bingo91.vip?code=JQ7LE5PZVN2&t=1743505710",
    },
    {
        id: "Jaiho777",
        name: "Jaiho 777",
        image: Jaiho777,
        bonus: 40,
        withdraw: 100,
        type: "download",
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
    {
        id: "Game3f",
        name: "GAME-3F",
        image: GAME3F,
        bonus: 51,
        withdraw: 100,
        type: "download",
        downloadLink: "http://api.gm3f.com/tYtp",
    },
    {
        id: "JaihoArcade",
        name: "Jaiho Arcade",
        image: JaihoArcade,
        bonus: 150,
        withdraw: 100,
        type: "download",
        downloadLink: "https://www.jaihoarcade38.com?code=AZDAPMZWQEG&t=1743506214",
    },
    {
        id: "MBMBET",
        name: "MBM-BET",
        image: MBMBET,
        bonus: 30,
        withdraw: 100,
        type: "download",
        downloadLink: "https://www.mbmbet3.com?code=UPHYXYY5RB2&t=1743506019",
    },
    {
        id: "jaihorummy",
        name: "Jaiho Rummy",
        image: jaihorummy,
        bonus: "150",
        withdraw: 100,
        type: "download",
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
    {
        id: "MDM Bet",
        name: "MDM Bet",
        image: MDMBet,
        bonus: 30,
        withdraw: 100,
        type: "download",
        downloadLink: "https://mdmagent.com/?code=0G7DQP73XBQ&t=1743505854",
    },
    {
        id: "MKMBet",
        name: "MKM Bet",
        image: MKMBet,
        bonus: 20,
        withdraw: 100,
        type: "download",
        downloadLink: "https://mkmbet.app/?code=MJ02YWZNVAX&t=1743505562",
    },
    {
        id: "MSMBet",
        name: "MSM Bet",
        image: MSMBet,
        bonus: 51,
        withdraw: 100,
        type: "download",
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
    {
        id: "My777",
        name: "My 777",
        image: My777,
        bonus: 77,
        withdraw: 100,
        type: "download",
        downloadLink: "https://my777app.com?code=WF1PZANL2TU&t=1743505975",
    },
    {
        id: "Rummy365",
        name: "Rummy 365",
        image: Rummy365,
        bonus: 38,
        withdraw: 100,
        type: "download",
        downloadLink: "https://rummy36506.in?code=YAZ31GHN7XQ&t=1743506149",
    },
    {
        id: "SpinLucky",
        name: "Spin Lucky",
        image: SpinLucky,
        bonus: 25,
        withdraw: 100,
        type: "download",
        downloadLink: "https://spinlucky.biz?code=FQ0ZV7GZBX3&t=1743505667",
    },
    {
        id: "SpinWinner",
        name: "Spin Winner",
        image: SpinWinner,
        bonus: 30,
        withdraw: 100,
        type: "download",
        downloadLink: "https://spinwinnerfreecash2.com?code=SDN3HSEU3HT&t=1743505530",
    },
    {
        id: "SPIN101",
        name: "SPIN 101",
        image: SPIN101,
        bonus: 50,
        withdraw: 100,
        type: "download",
        downloadLink: "http://spin101.click?code=P4CXHPQMY56&t=1743505745",
    },
    {
        id: "teenpattibliz",
        name: "teen patti bliz",
        image: teenpattibliz,
        bonus: "51",
        withdraw: "100",
        type: "download",
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
    {
        id: "teenpattimaster",
        name: "teen patti master",
        image: teenpattimaster,
        bonus: 51,
        withdraw: 100,
        type: "download",
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
    {
        id: "Yono777",
        name: "Yono 777",
        image: Yono777,
        bonus: 33,
        withdraw: 100,
        type: "download",
        downloadLink: "yono777.online?code=F9MRLKRGMS3&t=1743506097",
    },
    {
        id: "YonoArcade",
        name: "Yono Arcade",
        image: YonoArcade,
        bonus: 50,
        withdraw: 100,
        type: "download",
        downloadLink: "https://uonoarcadeapk.com?code=F55CH4V6DWL&t=1743506075",
    },
    {
        id: "YonoRummy",
        name: "Yono Rummy",
        image: YonoRummy,
        bonus: "30",
        withdraw: "100",
        type: "download",
        downloadLink: "https://yonorummyn.com?code=VIP8U797F7F&t=1743505897",
    },
    {
        id: "YonoSlots",
        name: "Yono Slots",
        image: YonoSlots,
        bonus: "Sign Up Bonus ₹25",
        withdraw: "Min Withdraw ₹100",
        type: "download",
        downloadLink: "https://www.yonoslotsj.com?code=V91QDJ3NLQY&t=1743506123",
    },
    {
        id: "YnRummy",
        name: "Yn Rummy",
        image: YnRummy,
        bonus: 100,
        withdraw: 100,
        type: "download",
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
    {
        id: "SlotsYono567",
        name: "567 Slots Yono",
        image: SlotsYono567,
        bonus: 38,
        withdraw: 100,
        type: "download",
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
    {
        id: "EN365YONO",
        name: "EN-365-YONO",
        image: EN365YONO,
        bonus: 238,
        withdraw: 100,
        type: "download",
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
    {
        id: "JaihoSpin",
        name: "Jaiho Spin",
        image: JaihoSpin,
        bonus: 500,
        withdraw: 500,
        type: "download",
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
    {
        id: "Rummy91",
        name: "Rummy 91",
        image: Rummy91,
        bonus: 191,
        withdraw: 100,
        type: "download",
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
    {
        id: "Rummy420",
        name: "Rummy-420",
        image: Rummy420,
        bonus: 500,
        withdraw: 100,
        type: "download",
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
    {
        id: "SlotsSpin",
        name: "Slots-Spin",
        image: SlotsSpin,
        bonus: 30,
        withdraw: 100,
        type: "download",
        downloadLink: "https://slotsspinp.com?code=XJB775PT3UB&t=1743506187",
    },
    {
        id: "SlotsWinner",
        name: "Slots-Winner",
        image: SlotsWinner,
        bonus: 20,
        withdraw: 100,
        type: "download",
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
    {
        id: "Spin777",
        name: "Spin-777",
        image: Spin777,
        bonus: 40,
        withdraw: 100,
        type: "download",
        downloadLink: "http://spin777d.in?code=7V9QK9E4DAA&t=1743505345",
    },
    {
        id: "SpinCrush",
        name: "Spin-Crush",
        image: SpinCrush,
        bonus: 77,
        withdraw: 100,
        type: "download",
        downloadLink: "https://2shisgjsqawwhsagui7c.Safelyearnmillionsbysharingonepersonaqfxzqyfw.com?code=ADENLFM2R93&t=1743505243",
    },
    {
        id: "SpinGold",
        name: "Spin-Gold",
        image: SpinGold,
        bonus: 45,
        withdraw: 100,
        type: "download",
        downloadLink: "https://spingoldagents.net/?code=HLTUBTRW8EG&t=1743505299",
    },
    {
        id: "Yn777",
        name: "Yn-777",
        image: Yn777,
        bonus: 38,
        withdraw: 100,
        type: "download",
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
    {
        id: "YonoAllGamesWinning",
        name: "Yono-AllGames-Winning",
        image: YonoAllGamesWinning,
        bonus: 151,
        withdraw: 100,
        type: "download",
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
    {
        id: "YonoAllGames",
        name: "Yono-All-Games",
        image: YonoAllGames,
        bonus: 51,
        withdraw: 100,
        type: "download",
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
    {
        id: "YonoApp",
        name: "Yono-App",
        image: YonoApp,
        bonus: 10,
        withdraw: 100,
        type: "download",
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
    {
        id: "YonoGames",
        name: "Yono-Games",
        image: YonoGames,
        bonus: 37,
        withdraw: 100,
        type: "download",
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
    {
        id: "YonoVip",
        name: "Yono-Vip",
        image: YonoVip,
        bonus: "25",
        withdraw: "100",
        type: "download",
        downloadLink: "https://yonovip2.com?code=3CRFKARZ5KM&t=1743505826",
    },
    {
        id: "AllYonoApps",
        name: "All Yono Apps",
        image: AllYonoApps,
        bonus: 51,
        withdraw: 100,
        type: "download",
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
    {
        id: "MQMBet",
        name: "MQM-Bet",
        image: MQMBet,
        bonus: 10,
        withdraw: 100,
        type: "download",
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
    {
        id: "MWMBET",
        name: "MWM.BET",
        image: MWMBET,
        bonus: 10,
        withdraw: 100,
        type: "download",
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
    {
        id: "SVIP777",
        name: "SVIP-777",
        image: SVIP777,
        bonus: 10,
        withdraw: 100,
        type: "download",
        downloadLink: "https://t.me/+KqCC7rTOCxU0YzJl",
    },
];

const GameDetail = () => {
    const { gameId } = useParams();
    const navigate = useNavigate();

    const game = games.find((g) => g.id === gameId);
    const otherGames = games.filter((g) => g.id !== gameId);

    if (!game) {
        return <Typography variant="h5" color="error">Game not found!</Typography>;
    }

    const handleDownload = () => {
        if (game.downloadLink) {
            window.location.href = game.downloadLink; // Navigate to download link
        } else {
            alert("Download link not available.");
        }
    };

    return (
        <div style={{ textAlign: "center", padding: "20px", background: "linear-gradient(to right, #000000, #ffd700)" }}>
            <Typography variant="h4" sx={{ marginBottom: "10px", color: "white" }}>{game.name}</Typography>

            {/* Main Game Card */}
            <Card sx={{ maxWidth: 400, margin: "auto", boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", }}>
                <CardMedia component="img" image={game.image} alt={game.name} sx={{ height: 450 }} />
                <CardContent>
                    <Typography color="red" sx={{ fontSize: "16px", fontWeight: "bold" }}>
                        Sign Up Bonus ₹{game.bonus}
                    </Typography>
                    <Typography color="green" sx={{ fontSize: "14px", marginBottom: "15px" }}>
                        Minimum Withdraw ₹{game.withdraw}
                    </Typography>

                    <Button
                        variant="contained"
                        sx={{
                            background: "blue",
                            color: "#fff",
                            padding: "10px 20px",
                            fontSize: "16px",
                            borderRadius: "20px",
                        }}
                        startIcon={<DownloadIcon />}
                        onClick={handleDownload} // Added onClick handler
                    >
                        Download {game.name} APK
                    </Button>
                </CardContent>
            </Card>

            {/* Other Games List */}
            <Typography variant="h5" sx={{ marginTop: "20px", marginBottom: "10px", color: "white" }}>
                Other Related Games
            </Typography>

            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                {otherGames.map((otherGame) => (
                    <Card
                        key={otherGame.id}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "10px",
                            marginBottom: "10px",
                            borderRadius: "10px",
                            boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
                            width: "90%",
                            maxWidth: "500px",
                            cursor: "pointer",
                        }}
                        onClick={() => navigate(`/game/${otherGame.id}`)}
                    >
                        {/* Game Image */}
                        <CardMedia
                            component="img"
                            image={otherGame.image}
                            alt={otherGame.name}
                            sx={{ width: 60, height: 60, borderRadius: "10px", marginRight: "10px" }}
                        />

                        {/* Game Info */}
                        <CardContent sx={{ flex: "1", padding: "0px" }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                {otherGame.name}
                            </Typography>
                            <Typography color="red" sx={{ fontSize: "14px", fontWeight: "bold" }}>
                                Bonus ₹{otherGame.bonus}
                            </Typography>
                            <Typography color="green" sx={{ fontSize: "14px" }}>
                                Min Withdraw ₹{otherGame.withdraw}
                            </Typography>
                        </CardContent>

                        {/* View Button */}
                        <Button
                            variant="contained"
                            sx={{
                                background: "linear-gradient(to right, orange, green)",
                                color: "#fff",
                                padding: "5px 10px",
                                fontSize: "14px",
                                borderRadius: "20px",
                            }}
                        >
                            View
                        </Button>
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default GameDetail;